<template>
  <div>
    <v-container
      v-if="user.hasApprovedLgdp"
      fill-height
      fluid
      class="pa-10"
      style="background-color: #f5f5f5"
    >
      <v-row :gutter="25">
        <v-col
          v-for="(item, i) in items"
          v-show="checkProfile(user.profile.id, item.allowedProfilesIds)"
          :key="i"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="3"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              :elevation="hover ? 16 : 1"
              outlined
              :to="item.to"
              style="border-radius: 15px"
            >
              <div class="d-flex justify-center text-center pa-5">
                <div>
                  <v-card-subtitle align="center" class="pa-0">
                    <v-img
                      contain
                      :src="require(`@/assets/img/${item.icon}.png`)"
                      transition="scale-transition"
                      width="100px"
                    />
                  </v-card-subtitle>
                  <br />
                  <span class="text-h6 text-center" v-text="item.title" />
                  <v-card-subtitle class="pt-2" v-text="item.subtitle" />
                </div>
              </div>
            </v-card>
          </v-hover>
        </v-col>

        <!-- Whatsapp do grupo -->
        <v-col
          v-for="(item, i) in whatsappLink"
          :key="i + items.length"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          xl="3"
        >
          <v-hover
            v-if="user.profile.id === profiles.EDUCANDO"
            v-slot="{ hover }"
          >
            <v-card
              :elevation="hover ? 16 : 1"
              outlined
              style="border-radius: 15px"
              @click="openWindow(item)"
            >
              <div class="d-flex justify-center text-center pa-5">
                <div>
                  <v-card-subtitle align="center" class="pa-0">
                    <v-img
                      contain
                      :src="require(`@/assets/img/whatsapp.png`)"
                      transition="scale-transition"
                      width="100px"
                    />
                  </v-card-subtitle>
                  <br />
                  <span class="text-h6 text-center"
                    >Whatsapp - {{ classesName[i] }}</span
                  >
                  <v-card-subtitle class="pt-2"
                    >Entre no grupo de whatsapp da turma {{ classesName[i] }} e
                    fique por dentro das novidades!</v-card-subtitle
                  >
                </div>
              </div>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>

    <v-container
      v-else
      fill-height
      fluid
      :class="$vuetify.breakpoint.smAndDown ? 'pa-6' : 'pa-10'"
      style="background-color: #f5f5f5"
    >
      <v-row>
        <v-col>
          <h1>Termo de Consentimento - LGPD</h1>

          <div class="pt-6" style="width: 80vw">
            <p>
              O PEJA - Bauru necessita dos seus dados pessoais (nome, sobrenome,
              data de entrada no PEJA, cpf, rg e demais dados sensíveis) para
              fins de cadastro na plataforma.
            </p>
            <p>
              Informamos que os dados somente serão utilizados para fins de
              acesso a plataforma, geração de declarações e demais atividades
              vinculadas ao website. Destacamos também que caso seja solicitado,
              a sua conta será apagada de forma permanente do nosso sistema.
            </p>
            <p>
              Para fins de segurança dos seus dados, eles são armazenados em
              banco de dados criptografados com acesso restrito. Além disso,
              todas as senhas possuem um nível de segurança mínimo.
            </p>
            <p>
              Caso queira utilizar o sistema e esteja de acordo com o
              armazenamento dos dados sensíveis, por favor, selecione a opção
              abaixo e clique em "CONCORDO, ENTRAR NO SISTEMA PEJA".
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-6">
        <v-col :align="$vuetify.breakpoint.smAndDown ? 'center' : 'end'">
          <v-btn
            large
            rounded
            color="secondary"
            :style="
              $vuetify.breakpoint.smAndDown
                ? 'font-size: 12px'
                : 'font-size: 16px'
            "
            @click="deleteUser"
          >
            DISCORDO, EXCLUIR MEUS DADOS
          </v-btn>
        </v-col>
        <v-col :align="$vuetify.breakpoint.smAndDown ? 'center' : 'start'">
          <v-btn
            large
            rounded
            color="primary"
            :style="
              $vuetify.breakpoint.smAndDown
                ? 'font-size: 12px'
                : 'font-size: 16px'
            "
            @click="agreeLgpd"
          >
            CONCORDO, ENTRAR NO SISTEMA PEJA
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { profiles } from '@/utils/Profiles';
// eslint-disable-next-line import/no-cycle
import {
  updateLgpdApprove,
  fetchCurrentUser,
  deleteUserLgpd,
} from '@/services/user';

// eslint-disable-next-line import/no-cycle
import { logout } from '@/services/auth';

export default {
  name: 'Dashboard',
  data: () => ({
    profiles,
    items: [
      {
        icon: 'user',
        title: 'MINHAS INFORMAÇÕES',
        subtitle: 'Visualize e edite suas informações pessoais cadastradas.',
        page: 'Account',
        to: '/account',
        allowedProfilesIds: [],
      },
      {
        icon: 'dashboard',
        title: 'INDICATIVOS',
        subtitle: 'Visualize os principais indicativos do projeto PEJA.',
        page: 'Indicatives',
        to: '/indicatives',
        allowedProfilesIds: [
          profiles.ADMINISTRADOR,
          profiles.COORDENADOR_DISCENTE,
          profiles.COORDENADOR_DOCENTE,
          profiles.MONITOR_BOLSISTA,
          profiles.MONITOR_VOLUNTARIO,
          profiles.EDUCANDO,
        ],
      },
      {
        icon: 'activities',
        title: 'ATIVIDADES',
        subtitle:
          'Visualize, adicione, edite e remova atividades do projeto PEJA.',
        page: 'Activities',
        to: '/activities',
        allowedProfilesIds: [
          profiles.ADMINISTRADOR,
          profiles.COORDENADOR_DISCENTE,
          profiles.COORDENADOR_DOCENTE,
          profiles.MONITOR_BOLSISTA,
          profiles.MONITOR_VOLUNTARIO,
        ],
      },
      {
        icon: 'private-files',
        title: 'ARQUIVOS PRIVADOS DO PROJETO',
        subtitle:
          'Gerencie os arquivos privados enviados pelo time interno do PEJA.',
        page: 'PrivateFiles',
        to: '/private-files',
        allowedProfilesIds: [
          profiles.ADMINISTRADOR,
          profiles.COORDENADOR_DISCENTE,
          profiles.COORDENADOR_DOCENTE,
          profiles.MONITOR_BOLSISTA,
          profiles.MONITOR_VOLUNTARIO,
        ],
      },
      {
        icon: 'files',
        title: 'ARQUIVOS PÚBLICOS DO PROJETO',
        subtitle:
          'Gerencie os arquivos que os educandos e usuários externos irão visualizar.',
        page: 'Files',
        to: '/files',
        allowedProfilesIds: [
          profiles.ADMINISTRADOR,
          profiles.COORDENADOR_DISCENTE,
          profiles.COORDENADOR_DOCENTE,
          profiles.MONITOR_BOLSISTA,
          profiles.MONITOR_VOLUNTARIO,
        ],
      },
      {
        icon: 'files',
        title: 'MATERIAIS DE ESTUDO',
        subtitle:
          'Clique aqui para ver os materiais disponíveis para o seu estudo.',
        page: 'Files',
        to: '/files',
        allowedProfilesIds: [profiles.EDUCANDO, profiles.USUARIO_EXTERNO],
      },
      {
        icon: 'people',
        title: 'USUÁRIOS',
        subtitle: 'Gerencie monitores, educandos e administradores.',
        page: 'Users',
        to: '/users',
        allowedProfilesIds: [
          profiles.ADMINISTRADOR,
          profiles.COORDENADOR_DISCENTE,
          profiles.COORDENADOR_DOCENTE,
          profiles.MONITOR_VOLUNTARIO,
          profiles.MONITOR_BOLSISTA,
        ],
      },
      {
        icon: 'teams',
        title: 'TURMAS',
        subtitle: 'Gerencie os educandos e as turmas do projeto PEJA.',
        page: 'Teams',
        to: '/teams',
        allowedProfilesIds: [
          profiles.ADMINISTRADOR,
          profiles.COORDENADOR_DISCENTE,
          profiles.COORDENADOR_DOCENTE,
        ],
      },
      {
        icon: 'calendar',
        title: 'EVENTOS',
        subtitle: 'Crie eventos para os monitores e educandos do PEJA.',
        page: 'Events',
        to: '/events',
        allowedProfilesIds: [
          profiles.ADMINISTRADOR,
          profiles.COORDENADOR_DISCENTE,
          profiles.COORDENADOR_DOCENTE,
        ],
      },
      {
        icon: 'email',
        title: 'COMUNICADOS',
        subtitle: 'Envie comunicados para os monitores e educandos.',
        page: 'Announcements',
        to: '/announcements',
        allowedProfilesIds: [
          profiles.ADMINISTRADOR,
          profiles.COORDENADOR_DISCENTE,
          profiles.COORDENADOR_DOCENTE,
        ],
      },
      {
        icon: 'certificates',
        title: 'DECLARAÇÕES',
        subtitle: 'Gere declaração para os monitores e educandos do PEJA.',
        page: 'Certificates',
        to: '/certificates',
        allowedProfilesIds: [
          profiles.ADMINISTRADOR,
          profiles.COORDENADOR_DISCENTE,
          profiles.COORDENADOR_DOCENTE,
        ],
      },
    ],
    whatsappLink: [],
    classesName: [],
  }),
  computed: {
    ...mapGetters({ user: 'user/getUser' }),
  },
  mounted() {
    if (
      this.user.profile.id === this.profiles.EDUCANDO &&
      this.user.classes.length > 0
    ) {
      this.user.classes.forEach((element) => {
        if (
          element.whatsappUrl &&
          element.whatsappUrl.includes('.whatsapp.com')
        ) {
          this.whatsappLink.push(element.whatsappUrl);
          this.classesName.push(element.name);
        }
      });
    }
  },
  methods: {
    ...mapActions('loading', ['showLoading', 'hideLoading']),
    checkProfile(profileId, allowedProfilesIds) {
      if (
        allowedProfilesIds.length > 0 &&
        !allowedProfilesIds.includes(profileId)
      ) {
        return false;
      }
      return true;
    },
    async deleteUser() {
      try {
        this.showLoading();
        await deleteUserLgpd();
        this.$root.vtoast.show({
          message: `Usuário excluído com sucesso.`,
          top: true,
          right: true,
          show: true,
          color: 'success',
        });
        await logout();
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao excluir o usuário',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    async agreeLgpd() {
      try {
        this.showLoading();
        const resultado = await updateLgpdApprove({
          hasApprovedLgdp: 'true',
        });

        if (resultado && !resultado.success) {
          this.$root.vtoast.show({
            message: 'Erro ao consentir com a LGPD.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        } else {
          this.$root.vtoast.show({
            message: `Status atualizado com sucesso.`,
            top: true,
            right: true,
            show: true,
            color: 'success',
          });
          await fetchCurrentUser();
        }
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao consentir com a LGPD.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    openWindow(url) {
      window.open(url);
    },
  },
};
</script>

<style scoped>
.iconDash {
  font-size: 100px;
}

.v-card {
  transition: opacity 0.4s ease-in-out;
  cursor: pointer;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>
